module.exports = __webpack_public_path__ + "img/add_to_apple_wallet_es.11428ee0.png";